import React, { FunctionComponent } from "react";

export const Advantages: FunctionComponent<{ productAdvantages: string[] }> = ({ productAdvantages }) => {
    return (
        <div className="product-advantage-block">
            <p className="product-advantage-title">Les plus produit</p>
            {productAdvantages.map((advantage, i) => (
                <div key={i} className="product-advantage-item">
                    <img src={"/assets/images/responsive/icons/plus.svg"} alt="icone plus" />
                    <p>{advantage}</p>
                </div>
            ))}
        </div>
    );
};

